import { Button, Popover, Row } from "antd";
import styled from "styled-components";

import { customFieldTypeFormatFunctions } from "common/utils";

const StyledButton = styled(Button)`
  padding-left: 0;
`;

const StyledInfoTitle = styled.div`
  color: grey;
`;

const StyledInfoValue = styled.div`
  margin-left: 4px;
`;

const StyledPopoverContent = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export default function UserDefinedFieldValues({ customFieldItems }) {
  if (customFieldItems.length === 0) {
    return "-";
  }

  const items = customFieldItems.map(({ field, slug, value }) => (
    <Row key={slug}>
      <StyledInfoTitle>{field.name}:</StyledInfoTitle>
      <StyledInfoValue>{customFieldTypeFormatFunctions[field.type](value)}</StyledInfoValue>
    </Row>
  ));

  if (customFieldItems.length < 4) {
    return <div>{items}</div>;
  }

  const popoverContent = (
    <StyledPopoverContent>
      {customFieldItems.map(({ field, slug, value }) => (
        <Row key={slug}>
          <StyledInfoTitle>{field.name}:</StyledInfoTitle>
          <StyledInfoValue>{customFieldTypeFormatFunctions[field.type](value)}</StyledInfoValue>
        </Row>
      ))}
    </StyledPopoverContent>
  );

  return (
    <div>
      {items.slice(0, 3)}
      <Popover
        content={popoverContent}
        title="User Defined Fields"
        trigger="click"
        placement="left"
      >
        <StyledButton type="link">See All</StyledButton>
      </Popover>
    </div>
  );
}
